import { Component } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar-component.component.html',
    styleUrls: ['./navbar-component.component.css'],
    standalone: false
})
export class NavbarComponentComponent {

  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
    .pipe(
      map(result => result.matches),
      shareReplay()
    );
    isExpanded:boolean=true;
  constructor(private breakpointObserver: BreakpointObserver) {}

}
